import React from 'react';
import { AnchorButton, Button, Icon, Intent, Popover, Position } from '@blueprintjs/core';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import Toast from 'helpers/toaster';

// "Share with customer" on the booking page: the booking's public link, plain
// or with your branding, each explained and copyable in one click.
// Styles: styles/booking-form.scss (.bk-share-link).

const OPTIONS = [
  {
    id: 'brand',
    icon: 'office',
    title: 'Link with your branding',
    text: 'Shows your logo, email and phone number above the booking. Best when you email or text it yourself, so customers know it\'s from you.',
    suffix: '?is_brand=true',
  },
  {
    id: 'plain',
    icon: 'link',
    title: 'Plain link',
    text: 'Just the booking, no header. Use it where your branding is already around it, like your own website or app.',
    suffix: '',
  },
];

const ShareBookingLink = ({ publicLink, confirmed }) => {
  if (!publicLink) return null;
  const panel = (
    <div className="bk-share-link">
      <div className="bk-share-link__head">
        <span className="bk-share-link__title">Share with your customer</span>
        <span className="bk-share-link__text">
          {confirmed
            ? 'They can see this booking. It\'s confirmed, so for changes the page asks them to contact you.'
            : 'They can see this booking and change the details until it\'s confirmed.'}
        </span>
      </div>
      {OPTIONS.map((option) => {
        const link = `${publicLink}${option.suffix}`;
        return (
          <div key={option.id} className="bk-share-link__option">
            <span className="bk-share-link__icon" aria-hidden="true"><Icon icon={option.icon} iconSize={16} /></span>
            <div className="bk-share-link__body">
              <span className="bk-share-link__option-title">{option.title}</span>
              <span className="bk-share-link__text">{option.text}</span>
              <div className="bk-share-link__actions">
                <CopyToClipboard
                  text={link}
                  onCopy={() => Toast.show({ icon: 'tick', message: `${option.title} copied`, intent: Intent.SUCCESS })}
                >
                  <Button small={true} intent={Intent.PRIMARY} icon="duplicate">Copy link</Button>
                </CopyToClipboard>
                <AnchorButton small={true} minimal={true} icon="share" href={link} target="_blank" rel="noopener noreferrer">
                  Open
                </AnchorButton>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
  return (
    <Popover content={panel} position={Position.BOTTOM_RIGHT} minimal={false}>
      <Button className="bk-btn" icon="share" rightIcon="caret-down" text="Share with customer" />
    </Popover>
  );
};

export default ShareBookingLink;
